class DnsLookup {
    getLookup(lookupType, callback) {
        $.ajax({
            url: euAdminConfig.base_uri + euAdminConfig.hostname + '/dnslookup/',
            type: 'post',
            data: {'type': lookupType},
            statusCode: {
                200: function(data) {
                    let status = 'valid';

                    if (!data.valid && !data.records.length) {
                        status = 'notValid';
                    }

                    if (!data.valid && data.records.length) {
                        status = 'different';
                    }

                    callback(status, data.records);
                }
            }
        }).fail(function() {
            callback('notFound', null);
        });
    }
}

export default DnsLookup;
